export const tabs = (i18n) => {
	return [
		{
			to: `/`,
			name: i18n`Requisition`,
		},
		{
			to: `/documents`,
			name: i18n`Documents`,
		},
		{
			to: `/history`,
			name: i18n`History`,
		},
	]
}
